import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';

import './polyfills';
import './index.css';
import App from './App/App';
import ErrorBoundary from './ErrorBoundary/ErrorBoundary';
import { ConfigurationProvider } from './contexts/ConfigurationContext';
import { AuthProvider } from './contexts/AuthContext';
import environment, { fetchEnvironment } from './utils/environment';

axios.defaults.headers.post['Content-Type'] = 'application/json';

fetchEnvironment().then(response => {
   const env = response.data;
   environment.api_insecure = env.insecure_endpoint;
   environment.api_secure = env.secure_endpoint;
   environment.captcha = env.captcha_sitekey;
   environment.sentry = env.sentry_dsn;

   ReactDOM.render(
      <ConfigurationProvider prefix={window.location.hostname.split('.')[0]}>
         <ErrorBoundary>
            <AuthProvider>
               <BrowserRouter>
                  <App />
               </BrowserRouter>
            </AuthProvider>
         </ErrorBoundary>
      </ConfigurationProvider>,
      document.getElementById('root')
   );
});



// WEBPACK FOOTER //
// ./src/index.js